import React from 'react';
import { useTranslation } from 'react-i18next';
import loginHeaderImg from "../../Images/Image/LoginTopBg.png";
import loginBottomImg from "../../Images/Image/LoginBottomBg.png";
import googleIcon from "../../Images/Image/google.png";
import facebookIcon from "../../Images/Image/fb.png";
import mobileIcon from "../../Images/Image/phone.png";
import HelpIcon from "../../Images/Image/HomePage/homeContactUs.png"
import CloseIcon from "../../Images/close.png";
import { useNavigate } from 'react-router-dom';
import { CredentialResponse, GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import LoginServices from '../../Services/Login';

// Reusable component for the section divider
const SectionDivider = ({ text }: any) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    width: '75%',
    margin: '20px auto',
  }}>
    <hr style={{
      flex: '1',
      border: 'none',
      borderTop: '1px solid black',
      margin: '0 10px',
    }} />
    <span style={{
      whiteSpace: 'nowrap',
      padding: '0 10px',
      color: '#555',
      fontSize: '16px',
      fontFamily: 'Arial, sans-serif'
    }}>
      {text}
    </span>
    <hr style={{
      flex: '1',
      border: 'none',
      borderTop: '1px solid black',
      margin: '0 10px',
    }} />
  </div>
);

// Reusable component for the login button with icon and text
const LoginButton = ({ icon, text, onClick }: any) => (
  <button
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      width: '80%',
      margin: '10px auto',
      padding: '12px 25px',
      borderRadius: '25px',
      border: '1px solid #d3d3d3',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      fontFamily: 'Arial, sans-serif',
      fontSize: '13px',
      color: '#333',
    }}
  >
    <div style={{ marginRight: '15px' }}>
      <img src={icon} alt="" style={{ width: "15px", height: "15px" }} />
    </div>
    <div style={{ color: "gray" }}>
      {text}
    </div>
  </button>
);

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    try {
      if (credentialResponse.credential) {
        const decoded: {
          name: string;
          email: string;
          picture: string;
          sub: string;
        } = jwt_decode(credentialResponse.credential);

        const name = decoded.name;
        const email: any = decoded.email;
        const token = credentialResponse.credential;
        const userimage = decoded.picture;

        await LoginServices.getUserLogin(
          "",
          "",
          email,
          "2",
          name,
          userimage,
          token,
          ""
        ).then((res: any) => {
          if (res?.status) {
            localStorage.setItem("Token", res?.result?.token);
            navigate("/");
                  localStorage?.setItem("signInMode", "3")
                              localStorage?.setItem("fixedUserId", res?.result?.fixedUserId)
                              localStorage.setItem("UserId", res?.result?.userId);
                              localStorage.setItem("Token", res?.result?.token);
                              localStorage.setItem("SignKey", res?.result?.signKey);
                              localStorage.setItem("UserName", res?.result?.userName);
                              localStorage.setItem("UserImage", res?.result?.userImage);
                              window?.location?.reload()
          }
        });
      }
    } catch (error) {
      console.log("Google login failed", error);
    }
  };

  const handleGoogleFailure = () => {
    console.log("Login Failed");
  };

  const handleFacebookLogin = () => {
    // Handle Facebook login logic
    console.log("Facebook Login clicked");
    
  };

  const handleMobileLogin = () => {
    // Handle mobile number login logic
    console.log("Mobile Number Login clicked");
    navigate("/loginWithNumber")
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      position: 'relative',
    }}>
      <div style={{ width: '100%' }}>
        <img src={loginHeaderImg} alt="Header" style={{ width: '100%' }} />
      </div>
      <img src={CloseIcon} onClick={() => navigate(-1)} style={{ position: "absolute", top: "5%", right: "8%", filter: "invert(100%) brightness(0%)" }} />

      <div style={{
        backgroundColor: '#fff3e0',
        padding: '20px',
        textAlign: 'center',
        alignSelf: 'center',
        marginTop: '35%',
        marginRight: '10%',
        marginLeft: '10%',
        borderRadius: '5%',
        boxShadow: '2px 2px 2px 1px lightgray'
      }}>
        {t('login_text')}
      </div>

      <SectionDivider text="लॉगिन विकल्प" />

      {/* Login Buttons Section */}
      <div style={{ flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <GoogleOAuthProvider clientId="510250012775-g24c2acnh0ccrvj9ltgkqnoago8i058r.apps.googleusercontent.com">

          {/* Custom Google Login Button */}
          <LoginButton
            icon={googleIcon}
            text="Google से लॉगिन करें"
            onClick={() => {
              const googleButton = document.querySelector(".google-login-button div[role='button']");
              if (googleButton) {
                (googleButton as HTMLElement).click();
              }
            }}
          />

          {/* Hidden GoogleLogin component */}
          <div className="google-login-button" style={{ display: 'none' }}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleFailure}
            />
          </div>
        </GoogleOAuthProvider>
        <LoginButton
          icon={facebookIcon}
          text="फेसबुक से लॉगिन करें"
          onClick={() => 
                window.FB.login(
                  (response: any) => {
                    if (response.authResponse) {
                      window.FB.api(
                        "/me",
                        { fields: "last_name, first_name, email" },
                        (userInfo: any) => {
                          const phoneNum = userInfo
                          const email: string = userInfo.email;
                          const accessToken: string = response.authResponse.accessToken;
                          localStorage.setItem("fcm", accessToken);

                          const name: string = userInfo.last_name
                            ? `${userInfo.first_name} ${userInfo.last_name}`
                            : userInfo.first_name;

                          const image: string = encodeURI(
                            `https://graph.facebook.com/${userInfo.id}/picture?type=large&width=1080`
                          );
                          LoginServices.getUserLogin(
                            "",
                            "",
                            email,
                            "3",
                            name,
                            "",
                            accessToken,
                            userInfo.id
                          ).then((res: any) => {
                            if (res?.status) {
                              // window?.location?.reload()
                              localStorage?.setItem("signInMode", "3")
                              localStorage?.setItem("fixedUserId", res?.result?.fixedUserId)
                              localStorage.setItem("UserId", res?.result?.userId);
                              localStorage.setItem("Token", res?.result?.token);
                              localStorage.setItem("SignKey", res?.result?.signKey);
                              localStorage.setItem("UserName", res?.result?.userName);
                              localStorage.setItem("UserImage", res?.result?.userImage);
                              window?.location?.reload()
                            }
                          });
                          // onClose();
                        }
                      );
                    } else {
                      console.log("Facebook login failed");
                    }
                  },
                  { scope: "email" }
                )

              }
          // onClick={handleFacebookLogin}
        />
        <LoginButton
          icon={mobileIcon}
          text="मोबाइल नंबर से लॉगिन करें"
          onClick={handleMobileLogin}
        />
      </div>

      <div style={{
        position: 'absolute',
        bottom: '10px',
        right: '20px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}>
        <img src={HelpIcon} alt="सहायता" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
        <span>सहायता</span>
      </div>

      <div style={{ marginTop: 'auto', width: '100%' }}>
        <img src={loginBottomImg} alt="Footer" style={{ width: '100%' }} />
      </div>
    </div>
  );
};

export default LoginPage;